import { Inverter } from '../../telemetry';
import { SocDetailSeries, SocSeries } from '../model';
import { getBatteriesSocBackgroundColors, getBatteriesSocColors } from '../styles.utils';

export class GraphSocHelper {
  data: { [key: string ]: SocSeries } = {};
  maxValue = Number.NEGATIVE_INFINITY;

  constructor(readonly series: { [key: string ]: Partial<Inverter>[] }, day: Date, tz: string) {
    day.setHours(12 - day.getTimezoneOffset() / 60 - Number(tz) / 4);
    const midDay = day.getTime();

    Object.entries(series).forEach(([key,telemetries])=>
      this.data[key] = Object.values(telemetries).reduce((prev: SocSeries, currentState) => {
          const keys = Object.keys(currentState) as Array<keyof Inverter>;
          keys.filter((key) => ['TS', '__typename'].includes(key) === false).forEach((key) => {
            const value: number = Number(currentState[key]);
            const currentTs = Number(currentState.TS) * 1000;
            let positionValue = Math.floor((currentTs - midDay) / 1000);
            positionValue = positionValue - (positionValue % 300);
            this.updateMaxValue(value);
            if (prev[key]) {
              const existingValue = prev[key].values.find((val) =>val[0] === positionValue);
              if (!existingValue) {
                prev[key].values.push([positionValue, value]);
              }
            } else {
              prev[key] = { name: key, values: [[positionValue, value]] };
            }
          });
          return prev;
        }, {})
    );

    Object.entries(this.data).forEach(([key,values]) => {
      Object.keys(values).forEach((v) => {
        if (values && values[v].values) {
          values[v].values.sort((a, b) => a[0] <= b[0] ? -1 : 1);
        }
      });
    });

  }

  updateMaxValue(value: number) {
    this.maxValue = this.maxValue < Math.abs(value) ? Math.abs(value) : this.maxValue;
  }

  getSocSeries() {
    if (!this.data) {
      throw new Error('Missing telemetry');
    }
    const colors = getBatteriesSocColors();
    const backgrounds = getBatteriesSocBackgroundColors();
    let styleIndex=0;

    let mappedSeries : SocDetailSeries[]=[];
    Object.entries(this.data).forEach(([key, series]) => {
      const seriesData = Object.values(series);
      const battery = seriesData.find(s => s.name === 'BP')?.values;
      const hasBattery = battery && this.hasNonZeroValue(battery);
      const battery1 = seriesData.find(s => s.name === 'BP1')?.values;
      const hasBattery1 = battery1 && this.hasNonZeroValue(battery1);
      const battery2 = seriesData.find(s => s.name === 'BP2')?.values;
      const hasBattery2= battery2 && this.hasNonZeroValue(battery2);
      if(hasBattery && (!hasBattery1 && !hasBattery2)){
        mappedSeries.push({
          name: key,
          values: battery,
          color: colors[styleIndex],
          background: backgrounds[styleIndex],
        })
        styleIndex +=1;
      }
      if(hasBattery1){
        mappedSeries.push({
          name: key+'_1',
          values: battery1,
          color: colors[styleIndex],
          background: backgrounds[styleIndex],

        })
        styleIndex +=1;
      }
      if(hasBattery2){
        mappedSeries.push({
          name:  key+'_2',
          values: battery2,
          color: colors[styleIndex],
          background: backgrounds[styleIndex],
        })
        styleIndex +=1;
      }
    });
    return mappedSeries;
  }

  hasNonZeroValue(arr: [number, number][]): boolean {
    return arr.some(([_, value]) => value !== 0);
  }

  getGraphOptions(appBuildStateOfChargeGraph: any,tz: string) {
    const series = this.getSocSeries();
    return {options : appBuildStateOfChargeGraph(series,tz), devices: series};
  }
}
